import { OverlaySocket } from "@ailenax-overlay/shared";
import { io } from 'socket.io-client';
import customParser from "socket.io-msgpack-parser";

// get token from query parameter
const urlParams = new URLSearchParams(window.location.search);
const token = urlParams.get('token');

export const socket: OverlaySocket = io(import.meta.env.VITE_OVERLAY_URL, {
    parser: customParser,
    auth: {
        token
    }
});

socket.on("reload-overlay", () => {
    window.location.reload();
});
